import { useAuth0 } from "@auth0/auth0-react";
import { isNil } from "lodash";
import { FunctionComponent, ReactNode, useEffect } from "react";

type Props = {
  children: ReactNode;
};

export const ProtectedRoute: FunctionComponent<Props> = (
  props: Props
): JSX.Element => {
  const { isAuthenticated, loginWithRedirect, isLoading, error } = useAuth0();

  useEffect(() => {
    if (!isNil(error)) {
      console.error(error);
    }
    if (!isAuthenticated && !isLoading && isNil(error)) {
      loginWithRedirect({ authorizationParams: { prompt: "login" } });
    }
  }, [isAuthenticated, isLoading, loginWithRedirect, error]);
  return <>{props.children}</>;
};

export default ProtectedRoute;
